import { Component, OnDestroy, OnInit } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { IEditorLanguage } from "@comunicare/comunicare-rule-editor";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FormsData } from "src/app/helpers/formsData";

@Component({
  selector: "app-rule-editor-container-page",
  templateUrl: "./rule-editor-container-page.component.html",
})
export class RuleEditorContainerPageComponent implements OnInit, OnDestroy {
  /** Languages a patient can be registered with. */
  public patientLanguages: IEditorLanguage[] = [];

  /** Languages a practitioner can be registered with, ie the languages the dashboard can be displayed in. */
  public practitionerLanguages: IEditorLanguage[] = [];

  /** Subject that emits when the component has been destroyed. */
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match
  private onDestroy$ = new Subject<void>();

  constructor(private formsData: FormsData, private translateService: TranslateService) {}

  public async ngOnInit(): Promise<void> {
    await this.loadLanguages();
    // language displays are translated in the current language: refresh them when it changes
    this.translateService.onLangChange.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.loadLanguages());
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * There is only one languages list on the server for now: the patient ones are all of them, the practitioner
   * ones are the subset the dashboard has translations for.
   */
  private async loadLanguages(): Promise<void> {
    let languages: IEditorLanguage[] = [];
    try {
      languages = (await this.formsData.getLanguages()).map((lang) => ({ code: lang.code, display: lang.display ?? lang.code }));
    } catch (error) {
      FileLogger.error("RuleEditorContainerPageComponent", "Server error while downloading languages", error);
    }

    const dashboardLangs = this.translateService.getLangs();
    this.patientLanguages = languages;
    this.practitionerLanguages = languages.filter((lang) => dashboardLangs.includes(lang.code));
  }
}
